import React from 'react';
import PropTypes from 'prop-types';
import { Outlet, Navigate } from 'react-router-dom';
import { isAuthenticated } from '../helper/authHelper';

function ProtectedRoute(props) {
  const { reverse } = props;
  const validate = reverse ? !isAuthenticated() : isAuthenticated();
  const defaultPath = reverse ? '/' : '/login';
  return validate ? <Outlet /> : <Navigate to={defaultPath} />;
}

ProtectedRoute.propTypes = {
  reverse: PropTypes.bool,
};

ProtectedRoute.defaultProps = {
  reverse: false,
};

export default React.memo(ProtectedRoute);
